import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import packageJson from "../package.json";
import { oidcConfig } from "./constants/api/autentiseringService/index";

import "./pollyfills";

// Import external styles
import "bootstrap/dist/css/bootstrap.css";
import "leaflet/dist/leaflet.css";

// Import internal styles
import "./styles/common.css";

import App from "./App";
import configureStore from "./store/configureStore";

// esri-leaflet error thrown as proj4 is not global (create-react-app shit?!)
import proj4 from "proj4";
window.proj4 = proj4;

console.log(packageJson.version); // ex: "1.0.0"

export const store = configureStore();

createRoot(document.getElementById("root")).render(
  <AuthProvider {...oidcConfig}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </AuthProvider>,
);

// Can't get it to work.
// Should only be used if not prod...
// if (module.hot) {
//   module.hot.accept("./AppContainer", () => {
//     const NextApp = require("./AppContainer").default;
//     ReactDOM.render(NextApp);
//   });
// }
